window.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isNew = urlParams.get('new');

  if (isNew === '1') {
    const target = document.querySelector('product-info .shopify-app-block');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }
});
// const apiURL = `https://no5c2rzdyb.execute-api.us-east-1.amazonaws.com/dev/exifTool?url=`;

const apiURL = `https://no5c2rzdyb.execute-api.us-east-1.amazonaws.com/dev/calculateInches?url=`;

$( document )
.ready(function() {
  $('[data-block="appendtobottom"]').each(function() {
    var _cpopup = $(this);
    $("body").append(_cpopup.clone(true))
    _cpopup.remove();
  })
})

// PLUS MINUS QUANTITY START
.on(`click`, `quantity-input .quantity__button[name="minus"],.customQtyFile__wrapper__minus`, function( e ) {
  try {
    e.stopImmediatePropagation();
    // const main  =   $( this ).closest( `.customQtyFile__wrapper` );
    main  =   $( this ).closest( `quantity-input` );
    let qty  =   main.find( `.quantity__input` ).val() * 1;
    if ( qty > 1 ) {
      // qty--;
      const winScreen = $( window ).width();
      if ( winScreen > 550 ) {
        // main.find( `.quantity__input` ).val( qty ).focus();
      } else {
        // main.find( `.quantity__input` ).val( qty );
      }
    }
    manageQuantities();
  } catch ( err ) {
    console.log( `ERROR .customQtyFile__wrapper__minus`, err.message );
  }
})

.on(`click`, `quantity-input .quantity__button[name="plus"],.customQtyFile__wrapper__plus`, function( e ) {
  try {
    e.stopImmediatePropagation();
    // const main = $( this ).closest( `.customQtyFile__wrapper` );
    main  =   $( this ).closest( `quantity-input` );
    let qty     =   main.find( `.quantity__input` ).val() * 1;
    // qty++;
    const winScreen = $( window ).width();
    if ( winScreen > 550 ) {
      // main.find( `.quantity__input` ).val( qty ).focus();
    } else {
      // main.find( `.quantity__input` ).val( qty );
    }
    manageQuantities();
  } catch ( err ) {
    console.log( `ERROR .customQtyFile__wrapper__plus`, err.message );
  }
})

.on(`keyup`, `quantity-input .quantity__input`, function( e ) {
  try {
    e.stopImmediatePropagation();
    manageQuantities();
  } catch ( err ) {
    console.log( `ERROR quantity-input .quantity__input`, err.message );
  }
})

// PLUS MINUS QUANTITY END

.on(`change`, `variant-radios fieldset.product-form__input[option="1"] .block-swatch > input[type="radio"]`, function( e ) {
  try {
    e.stopImmediatePropagation();
    // let isPopular = $( this ).closest( `.block-swatch` ).attr( `min` );
    // if ( isPopular == '' ) {
    //   $( `variant-radios fieldset.product-form__input[option="1"]` ).removeClass( `disabled` );
    //   $( `.widthHeight__option.customOption` ).removeClass( `selected` );
    //   $( `.widthHeight__option.popularOption` ).addClass( `selected` );
    //   $( `.widthHeight__custom .widthHeight__item__action` ).addClass( `disabled` );
    // } else {
    //   $( `variant-radios fieldset.product-form__input[option="1"]` ).addClass( `disabled` );
    //   $( `.widthHeight__option.customOption` ).addClass( `selected` );
    //   $( `.widthHeight__option.popularOption` ).removeClass( `selected` );
    //   $( `.widthHeight__custom .widthHeight__item__action` ).removeClass( `disabled` );
    // }

    setTimeout(()=>{
      // const vid = $( `[name="id"]` ).val() * 1;
      const vid = $( `.step__2 product-form .product-form__buttons` ).closest( `form` ).find( `[name="id"]` ).val() * 1;
      if ( typeof customTabelManage === 'function' ) {
        customTabelManage( vid, 'applyImg' );
      }
    }, 300);
  } catch ( err ) {
    console.log( `ERROR variant-radios fieldset.product-form__input[option="1"] .block-swatch > input[type="radio"]`, err.message );
  }
})

.on(`click`, `product-form quantity-input .qty-input__btn[name="plus"], product-form quantity-input .qty-input__btn[name="minus"]`, function( e ) {
  try {
    e.stopImmediatePropagation();
    setTimeout(()=>{
      // const vid = $( `[name="id"]` ).val() * 1;
      const vid = $( `.step__2 product-form .product-form__buttons` ).closest( `form` ).find( `[name="id"]` ).val() * 1;
      if ( typeof customTabelManage === 'function' ) {
        customTabelManage( vid, 'applyImg' );
      }
    }, 300);
  } catch ( err ) {
    console.log( `ERROR .product-form__variants .product-form__option[option="1"] .block-swatch-list .block-swatch .block-swatch__radio`, err.message );
  }
})

.on(`click`, `product-variants .product-variant .product-variant__item.product-variant__item--radio`, function( e ) {
  try {
    e.stopImmediatePropagation();
    setTimeout(()=>{
      // const vid = $( `[name="id"]` ).val() * 1;
      const vid = $( `.step__2 product-form .product-form__buttons` ).closest( `form` ).find( `[name="id"]` ).val() * 1;
      if ( typeof customTabelManage === 'function' ) {
        customTabelManage( vid, 'applyImg' );
      }
    }, 300);
  } catch ( err ) {
    console.log( `ERROR product-variants .product-variant .product-variant__item.product-variant__item--radio`, err.message );
  }
})

.on(`click`, `.customVariants .viewAllVariants a`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const isShowAllAvailable = $( this ).closest( `.customVariants` ).hasClass( `showAll` );
    // console.log ( 'isShowAllAvailable', isShowAllAvailable );
    if ( isShowAllAvailable ) {
      $( this )
        .closest( `.customVariants` )
        .find( `[visible]` )
        .attr( `visible`, 'hide' );
      $( this )
        .closest( `.customVariants` )
        .removeClass( `showAll` );
      $( this )
        .text( viewAllText );
    } else {
      $( this )
        .closest( `.customVariants` )
        .find( `[visible="hide"]` )
        .attr( `visible`, '' );
      $( this )
        .closest( `.customVariants` )
        .addClass( `showAll` );
      $( this )
        .text( viewLessText );
    }
    setTimeout(()=>{
      // const vid = $( `[name="id"]` ).val() * 1;
      const vid = $( `.step__2 product-form .product-form__buttons` ).closest( `form` ).find( `[name="id"]` ).val() * 1;
      if ( typeof customTabelManage === 'function' ) {
        customTabelManage( vid, 'applyImg' );
      }
    }, 300);
  } catch ( err ) {
    console.log( `ERROR .customVariants .viewAllVariants a`, err.message );
  }
})

.on(`click`, `.customVariant`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const modal     =   $( `.customVariant__modal` );
    const isActive  =   modal.hasClass( `active` );
    if ( isActive ) {
      modal.removeClass( `active` );
    } else {
      modal
        .find( `.customVariant__modal__centerCenter input[type="radio"], .customVariant__modal__centerCenter input[type="radio"] .visually-hidden` )
        .remove();
      modal.addClass( `active` );
    }
  } catch ( err ) {
    console.log( `ERROR .customVariant`, err.message );
  }
})

.on(`click`, `.customVariant__modal__close`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this ).closest( `.customVariant__modal` ).removeClass( `active` );
  } catch ( err ) {
    console.log( `ERROR .customVariant__modal__close`, err.message );
  }
})

.on(`click`, `.customQtyFile .customQtyFile__upload`,async function( e ) {
  try {
    e.stopImmediatePropagation();
    const newUploadField_available    =   $( `.customUploaderWrapper__upload` ).length;
    if ( newUploadField_available == 0 ) {
      const uploadFieldId             =   $( `.filepond--browser` ).attr( `id` );
      $( `.filepond--browser` )
        .attr( `title`, `` )
        .wrap( `<div class="customUploaderWrapper__upload hidden"></div>` );
    }
    await manageSteps( 1, 2 );
    await setSteps( 2, 1 );

    uploaderDataManage();

    $( `html, body` ).animate({
      scrollTop: $( `.customStep2_upload` ).offset().top
    }, 1000);

    setTimeout(()=>{
      const fileVal = $( `input[name="properties[Upload (Vector Files Preferred)]"]` ).length;

      console.log ( 'fileVal', fileVal );
      if ( fileVal > 0 ) {
        $( `.customUploaderWrapper__upload` ).addClass( `hidden` );
        $( `product-form.product-form, .uploaderFooterNote, .designerNote` ).show();

        $( `.uploaderFooterNoteSimpleLine` )
          .addClass( `hidden` );

        $( `.color-background-1.gradient` ).removeClass( `adjustHeight` );

        console.log ( 'show all ' );
      } else {
        $( `product-form.product-form, .uploaderFooterNote, .designerNote` ).hide();
        $( `.customUploaderWrapper__upload` ).removeClass( `hidden` );
        $( `.color-background-1.gradient` ).addClass( `adjustHeight` );
      }
    }, 1000);
  } catch ( err ) {
    console.log( `ERROR .customQtyFile .customQtyFile__upload`, err.message );
  }
})

.on(`change`, `.filepond--browser`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( `.customUploaderWrapper__upload` ).addClass( `hidden` );
    $( `.color-background-1.gradient` ).removeClass( `adjustHeight` );
    $( `.fileUploading_inprocess` ).addClass( `active` );
  } catch ( err ) {
    console.log( `ERROR .filepond--browser`, err.message );
  }
})

.on(`click`, `back-btn`,async function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this )
      .closest( `.product` )
      .removeClass( `changeLayout` );
    $( `.step__2` )
      .addClass( `hidden` );

    $( `[item-show-on]` ).addClass( `hidden` );
    $( `[item-show-on="afterUpload"]` ).removeClass( `hidden` );
    // $( `.customTabelPlace__item.selected` ).removeClass( `selected` );
  } catch ( err ) {
    console.log( `ERROR back-btn`, err.message );
  }
})
.on(`click`, `variant-radios .js.product-form__input label`, function( e ) {
  try {
    e.stopImmediatePropagation();
    setTimeout(()=>{
      // const vid = $( `[name="id"]` ).val() * 1;
      const vid = $( `.step__2 product-form .product-form__buttons` ).closest( `form` ).find( `[name="id"]` ).val() * 1;
      if ( typeof customTabelManage === 'function' ) {
        customTabelManage( vid, 'applyImg' );
      }
    }, 300);
  } catch ( err ) {
    console.log( `ERROR variant-radios .js product-form__input label`, err.message );
  }
})
.on(`click`, `.customPrecut__fieldset label`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this )
      .closest( `.customPrecut__fieldset` )
      .find( `label` )
      .removeClass( `selectedOption` );

    $( this )
      .addClass( `selectedOption` );

    setTimeout(()=>{
      // const vid = $( `[name="id"]` ).val() * 1;
      const vid = $( `.step__2 product-form .product-form__buttons` ).closest( `form` ).find( `[name="id"]` ).val() * 1;
      if ( typeof customTabelManage === 'function' ) {
        customTabelManage( vid, 'applyImg' );
      }
    }, 300);
  } catch ( err ) {
    console.log( `ERROR .customPrecut__fieldset label`, err.message );
  }
})
.on(`keyup`, `[name="properties[Design Notes]"]`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const designNote            =   $( this ).val();
    const isDesignNoteAvailable =   $( `product-form.product-form form textarea[name="properties[Design Notes]"]` ).length;
    if ( isDesignNoteAvailable > 0 ) {
      $( `product-form.product-form form textarea[name="properties[Design Notes]"]` ).val( designNote );
    } else {
      $( `product-form.product-form form` )
        .append( `
          <textarea name="properties[Design Notes]" style="display: none;">${ designNote }</textarea>
        ` );
    }
  } catch ( err ) {
    console.log( `ERROR [name="properties[Design Notes]"]`, err.message );
  }
})
.on(`click`, `.uploaderStep2FooterBtn`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const qty = $( `[name="quantity"]` ).val();
    const vid = $( `[name="id"]` ).val();
    const getFile = $( `[name="properties[Upload (Vector Files Preferred)]"]` ).val();
    const fileName = $( `.filepond--list-scroller .filepond--list .filepond--item .filepond--file-wrapper legend` ).text().trim();
    $( `.shopify-block.shopify-app-block [data-upload-field]` )
      .hide()
      .after( `
        <div class="afterUploadAdd2Cart">
          File<br>
          <ul class="afterUploadAdd2Cart__files ${ fileName == '' ? 'hidden' : '' }">
            <li class="afterUploadAdd2Cart__filesItem">
              <div class="text__">
                ${ fileName }
              </div>
              <div class="del__">
                <svg enable-background="new 0 0 32 32" id="Glyph" version="1.1" viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M6,12v15c0,1.654,1.346,3,3,3h14c1.654,0,3-1.346,3-3V12H6z M12,25c0,0.552-0.448,1-1,1s-1-0.448-1-1v-9  c0-0.552,0.448-1,1-1s1,0.448,1,1V25z M17,25c0,0.552-0.448,1-1,1s-1-0.448-1-1v-9c0-0.552,0.448-1,1-1s1,0.448,1,1V25z M22,25  c0,0.552-0.448,1-1,1s-1-0.448-1-1v-9c0-0.552,0.448-1,1-1s1,0.448,1,1V25z" id="XMLID_237_"/><path d="M27,6h-6V5c0-1.654-1.346-3-3-3h-4c-1.654,0-3,1.346-3,3v1H5C3.897,6,3,6.897,3,8v1c0,0.552,0.448,1,1,1h24  c0.552,0,1-0.448,1-1V8C29,6.897,28.103,6,27,6z M13,5c0-0.551,0.449-1,1-1h4c0.551,0,1,0.449,1,1v1h-6V5z" id="XMLID_243_"/></svg>
              </div>
            </li>
          </ul>
          <form action="/cart/add">
            <div class="afterUploadAdd2Cart__noteWrap">
              Leave a note for designer<br>
              <textarea name="note" class="afterUploadAdd2Cart__note" placeholder="Hint text"></textarea>
            </div>
            <input type="hidden" name="quantity" value="${ qty }">
            <input type="hidden" name="id" value="${ vid }">
            <input type="hidden" name="properties[Upload (Vector Files Preferred)]" value="${ getFile }">

            <button class="afterUploadAdd2Cart__btn">
              Add to cart
            </button>
          </form>
        </div>
      ` );
    manageSteps( 2, 3 );
    $( `.customStep2_upload back-btn` )
      .attr({
        "show-step": 2,
        "hide-step": 3
      });
  } catch ( err ) {
    console.log( `ERROR .uploaderStep2FooterBtn`, err.message );
  }
})

.on(`click`, `.afterUploadAdd2Cart__filesItem .del__`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( `.filepond--list-scroller .filepond--list .filepond--item .filepond--file-wrapper .filepond--file-action-button.filepond--action-remove-item` ).click();
    $( this )
      .closest( `.afterUploadAdd2Cart__files` )
      .remove();
    $( `.uploaderStep2FooterBtn` ).remove();
    $( `[name="properties[Upload (Vector Files Preferred)]"]` ).val( '' );
    $( `.customQtyFile__upload` ).click();
    $( `.afterUploadAdd2Cart` ).remove();
  } catch ( err ) {
    console.log( `ERROR .afterUploadAdd2Cart__filesItem .del__`, err.message );
  }
})
.on(`click`, `.step__1 .goToNextStep`,async function( e ) {
  try {
    e.stopImmediatePropagation();

    $( `.step__2` ).addClass( `loader` );

    if ( typeof file_height === 'undefined' ) {
      await getMeta(uploadedFile, (err, img) => {
        console.log(img.naturalWidth, img.naturalHeight);
        file_width  =   img.naturalWidth;
        file_height =   img.naturalHeight;

        $( `.widthHeight__block [name="height__value"]` )
          .val( `${ (file_height / 300).toFixed(2) }` );
        $( `.widthHeight__block [name="width__value"]` )
          .val( `${ (file_width / 300).toFixed(2) }` );
      });
      await addDelay( 500 );
    }

    $( this )
      .closest( `.product` )
      .addClass( `changeLayout` );

    $( `.step__2` )
      .removeClass( `hidden` );
    $(".customTabelPlace__item:first").addClass("selected");
    const height  = file_height / 300;
    const width   = file_width / 300;

    $( `[item-show-on]` )
      .addClass( `hidden` );

    $( `[item-show-on="finalStep"], [item-show-on="onAll"]` )
      .removeClass( `hidden` );

    $( `.widthHeight__block [name="height__value"]` )
      .val( height.toFixed(2) )
      .attr( `last`, height.toFixed(2) );

    $( `.widthHeight__block [name="width__value"]` )
      .val( width.toFixed(2) )
      .attr( `last`, width.toFixed(2) );

    calculateRatio( width.toFixed(2), height.toFixed(2) );
    // console.log ( 'getFileRatio', getFileRatio );
    await addDelay( 300 );
    getVariantsBySize();

    await addDelay( 100 );
    manageQuantities( 'btnClicked' );

    $( `.step__2` )
      .removeClass( `loader` );

    $( `.fileUploading_inprocess` ).removeClass( `active` );

    // $( `.product-form__payment-container .product-form__add-button` ).text( languages.productFormAddToCart );

  } catch ( err ) {
    console.log( `ERROR .step__1 .goToNextStep`, err.message );
  }
})
.one(`click`, `.product-form .add-to-cart[data-main-product-add-to-cart]`,async function( e ) {
  try {
    if ( typeof ElementAvailibility === 'function' ) {
      console.log( 'function inn' );
      if ( typeof afterAddtoCart_goCart_redirect !== 'undefined' && afterAddtoCart_goCart_redirect ) {
        $( `body` )
          .append( `
            <div class="loadingScreen__">
              <img src="${ loaderGif }">
            </div>
          ` );
        $( `sidebar-drawer#site-cart-sidebar` )
          .css( 'opacity', '0 !important' );

        console.log( 'after cart redirect' );
      }
      console.log( 'anotherTransfer', anotherTransfer );
      if ( typeof afterAddtoCart_goCart_redirect !== 'undefined' && afterAddtoCart_goCart_redirect && anotherTransfer == false ) {
        $( `sidebar-drawer#site-cart-sidebar` )
          .css( 'opacity', '0 !important' );

        console.log( 'another transfer' );
      }
      ElementAvailibility ( `#site-cart-sidebar.sidebar.sidebar--opened`, 'removeUploadError', 30 );
    }
  } catch ( err ) {
    console.log( `ERROR product-form__submit`, err.message );
  }
})
;


function removeUploadError() {
  try {
    $( `.cl-upload--errors.open` ).remove();

    if ( typeof afterAddtoCart_goCart_redirect !== 'undefined' && afterAddtoCart_goCart_redirect && anotherTransfer == false ) {
      $( `#site-cart-sidebar.sidebar.sidebar--opened` ).removeClass( `sidebar--opened` );
      anotherTransfer = false;
      location.href = '/cart';
    } else {
      anotherTransfer = false;
    }
    setTimeout(() => {
      $( `sidebar-drawer#site-cart-sidebar` )
        .css( 'opacity', '1' );
      $( `.loadingScreen__` ).remove();
    }, 2000);
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

function manageQuantities( type = '' ) {
  try {
    console.log ( 'manageQuantities chaaa__' );
    let qty         = $( `.qty_addtocart--wrapper quantity-input .quantity__input` ).val();
    if ( typeof qty !== 'undefined' && qty ) {
      qty = qty * 1;
    } else {
      qty = $( `.step__2 quantity-input .quantity__input` ).val();
      if ( typeof qty !== 'undefined' && qty ) {
        qty = qty * 1;
      }
    }
    console.log ( 'qty', qty );
    let selectedIndex = 0;
    $( `preCutPrice` ).text( `` );
    const isPreCutActive = $( `#precutselected` ).is( `:checked` );
    let preCutPrice;
    $( `.customTabelPlace .customTabelPlace__item` ).each(function() {
      const min     = $( this ).attr( `min` ) * 1;
      const max     = $( this ).attr( `max` ) * 1;
      const indexNo = $( this ).attr( `index` ) * 1;
      if ( qty >= min && qty <= max ) {
        selectedIndex = indexNo;
        const percentage  = $( this ).find( `.customTabelPlace__item_2` ).text().trim();
        let getDiscountedPricenly = $( this ).find( `.customTabelPlace__item_3 discount` ).text().trim();
        let unitPrice   = $( this ).find( `.customTabelPlace__item_3` ).text().trim();

        if ( isPreCutActive ) {
          preCutPrice = $( this ).attr( `pre-cut` );
          $( `pre-cut` ).text( `($${ preCutPrice } each)` );
          preCutPrice = preCutPrice * 1;
          getDiscountedPricenly_ = getDiscountedPricenly * 1;

          let together = (getDiscountedPricenly_ + preCutPrice).toFixed(2);
          // together = together * 1;

          unitPrice = unitPrice.replace( getDiscountedPricenly, together );
        } else {
          $( `pre-cut` ).text( `` );
        }
        $( `.customQtyFile__selectedData.percentage` ).html( `${ percentage !== '' ? percentage : `&nbsp;` }` );
        $( `.customQtyFile__selectedData.unitPrice > span` ).html( `${ unitPrice !== '' ? `${ unitPrice }${ typeof isPreCutActive !== 'undefined' && isPreCutActive ? ` <span style="font-weight: 400; font-size: small;">with precut</span>` : `` }${ typeof textUnderPrice !== 'undefined' && textUnderPrice ? `<div style="font-weight: normal; font-size: 0.8rem;">${ textUnderPrice }</div>` : '' }` : `&nbsp;` }` );
        $( `.product-form__info-list .product-form__info-content .price-list .price` )
          .html( unitPrice );
      }
    })
    if ( type != 'btnClicked' ) {
      $( `.customTabelPlace .customTabelPlace__item` ).removeClass( `selected` );
      $( `.customTabelPlace .customTabelPlace__item[index="${ selectedIndex }"]` ).addClass( `selected` );
    }
    const getEliteDiscount = $( `.customTabelPlace__item.selected .customTabelPlace__item_4` ).text().trim();
    if ( typeof customerIsMember !== 'undefined' && customerIsMember && typeof getEliteDiscount !== 'undefined' && getEliteDiscount ) {
      $( `.customQtyFile__selectedData.unitPrice > span` ).html( `${ getEliteDiscount !== '' ? `${ getEliteDiscount }${ typeof textUnderPrice !== 'undefined' && textUnderPrice ? `<div style="font-weight: normal; font-size: 0.8rem;">${ textUnderPrice }</div>` : '' }` : `&nbsp;` }` );
    }

    if ( selectedIndex != 0 ) {
      $( `.customTabelPlace__item` ).removeClass( `selected` );
      $( `.customTabelPlace__item[index="${ selectedIndex }"]` ).addClass( `selected` );
      const getPrecutVal = $( `.customTabelPlaceWrap .customTabelPlace__item[index="${ selectedIndex }"]` ).attr( `pre-cut` );
      if ( typeof getPrecutVal !== 'undefined' && getPrecutVal && isPreCutActive ) {
        precutVal = `Yes - Pre cut ($${ getPrecutVal } extra each)`;

        $( `.form__properties input[name="properties[precut]"]` ).remove();
        setTimeout(() => {
          $( `.form__properties` )
            .append( `<input type="hidden" name="properties[precut]" value="${ precutVal }">` );
        }, 100);

        setTimeout(() => {
          const checkPrecutLen = $( `.form__properties input[name="properties[precut]"]` ).length;

          if ( checkPrecutLen > 1 ) {
            $( `.form__properties input[name="properties[precut]"]` ).remove();
            $( `.form__properties` ).append( `<input type="hidden" name="properties[precut]" value="${ precutVal }">` );
          }
        }, 1000);
      } else {
        $( `.form__properties input[name="properties[precut]"]` ).remove();
      }
    }

    console.log ( 'selectedIndex', selectedIndex );

    if ( typeof allCartItems !== 'undefined' && allCartItems.length > 0 ) {
      alreadyInCart();
    }
    totalPriceToShow(qty, selectedIndex);
  } catch ( err ) {
    console.log( `ERROR manageQuantities`, err.message );
  }
}

async function totalPriceToShow( qty, selectedIndex ) {
  try {
    let getPrice = $( `.customTabelPlaceWrap .customTabelPlace__item[index="${ selectedIndex }"] .customTabelPlace__item_3 discount` ).text();
    let eachPrice;
    if ( typeof getPrice !== 'undefined' && getPrice ) {
      eachPrice = getPrice;
      getPrice = getPrice.trim() * 1;
    }
    getPrice = ( qty * getPrice ).toFixed( 2 );
    $( `total-price-display` ).html( `${ currencySymbol }${ getPrice }${ eachPrice != '' ? ` <small>(${ currencySymbol }${ eachPrice } each)</small>`:`` }` );
    $( `.product-form__buttons .product-form__submit` ).prop( `disabled`, false );
  } catch ( err ) {
    console.log( `ERROR totalPriceToShow`, err.message );
  }
}

function alreadyInCart() {
  try {
    const tickIcon = `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"/></svg>`;
    if ( allCartItems.length > 0 ) {
      const getVID = $( `.product-form [name="id"]` ).val() * 1;
      if ( typeof getVID !== 'undefined' && getVID && typeof findObjectByKey === 'function' ) {
        const matchedObj = findObjectByKey( allCartItems, 'variant_id', getVID );
        if ( typeof matchedObj !== 'undefined' && matchedObj ) {
          $( `.customTabelPlaceWrap .customTabelPlace__item` ).removeClass( `inCart` ).find( `.customTabelPlace__item_inCart` ).html( `` );
          $( `.customTabelPlaceWrap .customTabelPlace__item` ).each(function() {
            const min = $( this ).attr( `min` ) * 1;
            const max = $( this ).attr( `max` ) * 1;
            if ( matchedObj.quantity >= min && matchedObj.quantity <= max ) {
              console.log ( 'this row is matched',  );
              $( this ).addClass( `inCart` ).find( `.customTabelPlace__item_inCart` ).html( `${ tickIcon } You already have ${ matchedObj.quantity } pieces in Cart` );
            }
          })
        }
        console.log ( 'matchedObj', matchedObj );
      }
    }
  } catch ( err ) {
    console.log( `ERROR alreadyInCart`, err.message );
  }
}



function getRadioMaintain( by ) {
  try {
    let width       = document.querySelector( `.widthHeight__value[name="width__value"]` );
    let height      = document.querySelector( `.widthHeight__value[name="height__value"]` );

    let widthMax    = width.getAttribute( `max` ) * 1;
    let heightMax   = height.getAttribute( `max` ) * 1;

    let widthLast   = width.getAttribute( `last` );
    let heightLast  = height.getAttribute( `last` );

    const widthVal  = width.value * 1;
    const heightVal = height.value * 1;

    const getWidth  = ratioBy( 'w', widthVal, heightVal );
    const getHeight = ratioBy( 'h', widthVal, heightVal );

    let autoChange  = false;
    const checkAutoChangeEle = $( `.widthHeight__autoChange .autoChange` ).length;

    if ( checkAutoChangeEle > 0 ) {
      const isEnabledAutoChange = $( `.widthHeight__autoChange .autoChange` ).is( ':checked' );
      if ( isEnabledAutoChange ) {
        autoChange  = true;
      }
    }

    if ( typeof autoChange !== 'undefined' && autoChange ) {

      if ( by == 'width' ) {
        height.value = getHeight.toFixed(2);
        if ( getHeight > userDefinedMaxLength ) {
          $( `.widthHeight__item[by="height"]` ).addClass( `error` );
        }
      } else if ( by == 'height' ) {
        width.value  = getWidth.toFixed(2);
        if ( getWidth > userDefinedMaxLength ) {
          $( `.widthHeight__item[by="width"]` ).addClass( `error` );
        }
      }
    }

    getVariantsBySize();
  } catch ( err ) {
    console.log( `ERROR getRadioMaintain`, err.message );
  }
}


function reAdjustSizes() {
  try {
    const height    =   $( `input[name="height__value"]` );
    const width     =   $( `input[name="width__value"]` );

    const heightVal =   height.val() * 1;
    const widthVal  =   width.val() * 1;

    if ( widthVal > userDefinedMaxLength || heightVal > userDefinedMaxLength ) {
      if ( widthVal == heightVal ) {
        if ( widthVal > userDefinedMaxLength ) {
          console.log ( '11111' );
          width
            .val( userDefinedMaxLength.toFixed(2) )
            .prop( userDefinedMaxLength.toFixed(2) );
          getRadioMaintain( 'width' );
          $( `.widthHeight__item` ).addClass( `error` );
        }
      } else if ( widthVal > userDefinedMaxLength && heightVal > userDefinedMaxLength ) {
        if ( widthVal > heightVal ) {
          console.log ( '22222' );
          width
            .val( userDefinedMaxLength.toFixed(2) )
            .prop( userDefinedMaxLength.toFixed(2) );
          getRadioMaintain( 'width' );
          $( `.widthHeight__item` ).removeClass( `error` );
          $( `.widthHeight__item[by="width"]` ).addClass( `error` );
        } else if ( heightVal > widthVal ) {
          console.log ( '33333' );
          height
            .val( userDefinedMaxLength.toFixed(2) )
            .prop( userDefinedMaxLength.toFixed(2) );
          getRadioMaintain( 'height' );
          $( `.widthHeight__item` ).removeClass( `error` );
          $( `.widthHeight__item[by="height"]` ).addClass( `error` );
        }
      } else if ( widthVal > userDefinedMaxLength && heightVal < userDefinedMaxLength ) {
        console.log ( '44444' );
        width
          .val( userDefinedMaxLength.toFixed(2) )
          .prop( userDefinedMaxLength.toFixed(2) );
        getRadioMaintain( 'width' );
        $( `.widthHeight__item` ).removeClass( `error` );
        $( `.widthHeight__item[by="width"]` ).addClass( `error` );
      } else if ( heightVal > userDefinedMaxLength && widthVal < userDefinedMaxLength ) {
        console.log ( '55555' );
        height
          .val( userDefinedMaxLength.toFixed(2) )
          .prop( userDefinedMaxLength.toFixed(2) );
        getRadioMaintain( 'height' );
        $( `.widthHeight__item` ).removeClass( `error` );
        $( `.widthHeight__item[by="height"]` ).addClass( `error` );
      }
    } else {
      setTimeout(()=>{
        $( `.widthHeight__item` ).removeClass( `error` );
      }, 4000);
    }

    setTimeout(()=>{
      manageQuantities( `btnClicked` );
    }, 500);
  } catch ( err ) {
    console.log( `ERROR reAdjustSizes()`, err.message );
  }
}


function checkSelectedOption() {
  try {
    const isCustomOptionSelected = $( `.widthHeight__block .widthHeight__option.customOption` ).hasClass( `selected` );
    if ( typeof isCustomOptionSelected !== 'undefined' && isCustomOptionSelected ) {
      $( `product-form .product-form__buttons .formProperties` ).remove();
      const getWidth = $( `.widthHeight__block .widthHeight__custom .widthHeight__item__action[by="width"] .widthHeight__value[name="width__value"]` ).val();
      const getHeight = $( `.widthHeight__block .widthHeight__custom .widthHeight__item__action[by="height"] .widthHeight__value[name="height__value"]` ).val();
      $( `product-form .product-form__buttons` ).append( `
        <div class="formProperties" style="display: none;">
          <input type="hidden" name="properties[width]" value="${ getWidth }">
          <input type="hidden" name="properties[height]" value="${ getHeight }">
      ` );
    }
  } catch ( err ) {
    console.log( `ERROR checkSelectedOption()`, err.message );
  }
}


async function getVariantsBySize() {
  try {
    const getWidth    =   $( `.widthHeight__item__action .widthHeight__value[name="width__value"]` ).val() * 1;
    const getHeight   =   $( `.widthHeight__item__action .widthHeight__value[name="height__value"]` ).val() * 1;
    const getSquareIn =   Math.ceil( getWidth * getHeight );
    console.log ( 'getSquareIn', getSquareIn );
    let isVariantMatched  =   false;

    $( `variant-radios fieldset.product-form__input[option="1"] .block-swatch:not([min=""][max=""])` ).each(function() {
      const min = $( this ).attr( `min` ) * 1;
      const max = $( this ).attr( `max` ) * 1;
      if ( getSquareIn >= min && getSquareIn <= max ) {
        isVariantMatched  =   true;
        console.log ( 'matched variant id', $( this ).find( `label` ).attr( `for` ) );
        $( this ).find( `label` ).click();
      }
    })

    console.log ( 'isVariantMatched', isVariantMatched );

    if ( isVariantMatched ) {

      await addDelay( 300 );
      $( `.widthHeight__option.customOption` ).click();

    } else if ( getSquareIn > allowedMaxInches && getWidth > userDefinedMaxLength || getSquareIn > allowedMaxInches && getHeight > userDefinedMaxLength ) {

      await addDelay( 300 );
      $( `.widthHeight__item` ).addClass( `error` );
      $( `.widthHeight__option.customOption` ).click();

      const autoChangeCheckbox = $( `.widthHeight__autoChange #autoChange` ).is( `:checked` );

      if ( autoChangeCheckbox == false ) {
        $( `.widthHeight__autoChange #autoChange` ).click();
        await addDelay( 50 );

        $( `.widthHeight__item__action[by="height"] .widthHeight__item__action-plus` ).click();

        await addDelay( 100 );
        $( `.widthHeight__autoChange #autoChange` ).click();
      }
      console.log ( 'autoChangeCheckbox', autoChangeCheckbox );
    } else {
      const isMinMax_available = $( `variant-radios fieldset.product-form__input[option="1"] .block-swatch[min="470"][max="509"]` ).length;
      if ( isMinMax_available > 0 ) {
        $( `variant-radios fieldset.product-form__input[option="1"] .block-swatch[min="470"][max="509"]` )
          .find( `label` )
          .click();
      } else {
        $( `variant-radios fieldset.product-form__input[option="1"] .block-swatch[min][max]` )
          .first( `label` )
          .click();
      }

      await addDelay( 300 );

      console.log ( 'no variant matched' );
    }

    manageProperties();
  } catch ( err ) {
    console.log( `ERROR getVariantsBySize()`, err.message );
  }
}

function manageProperties() {
  try {
    const getWidth    =   $( `.widthHeight__item__action .widthHeight__value[name="width__value"]` ).val() * 1;
    const getHeight   =   $( `.widthHeight__item__action .widthHeight__value[name="height__value"]` ).val() * 1;
    let detectedSize  =   $( `.widthHeight__option-detectedSize span[d-size]` ).text();
    detectedSize      =   detectedSize.replace( '"', '' ).replace( '"', '' ).replace( ' ', '' ).replace( ' ', '' );

    const isPopularSizeSelected   =   $( `.widthHeight__option.popularOption.selected` ).length;

    if ( isPopularSizeSelected > 0 ) {
      $( `.form__properties` )
        .html( `` );
        // .html( `
        //   <textarea style="display: none;" name="properties[_specialNote]">Detected Size: ${ typeof detectedSize !== 'undefined' && detectedSize ? detectedSize : null }</textarea>
        // ` );
    } else {
      $( `variant-radios fieldset.product-form__input[option="1"]` ).addClass( `disabled` );
      console.log ( 'getWidth', getWidth );
      if ( typeof getWidth !== 'undefined' && getWidth ) {
        console.log ( 'getWidth chaa', getWidth );
        console.log ( 'getHeight', getHeight );
        $( `.form__properties` )
          .html( `
            <input type="hidden" name="properties[width]" value="${ getWidth }">
            <input type="hidden" name="properties[height]" value="${ getHeight }">
          ` );
          // <input type="hidden" name="properties[Detected Size]" value="${ detectedSize }">
      }
    }
    setTimeout(() => {
      if ( getWidth > getHeight && getWidth > userDefinedMaxLength ) {
        console.log ( 'chaaaaaaaa 111',  );
        $( `.widthHeight__custom .widthHeight__value[name="width__value"] + .widthHeight__item__action-plus` ).click();
      } else if ( getWidth < getHeight && getHeight > userDefinedMaxLength ) {
        $( `.widthHeight__custom .widthHeight__value[name="height__value"] + .widthHeight__item__action-plus` ).click();
        console.log ( 'chaaaaaaaa 222',  );
      } else if ( getWidth == getHeight && getHeight > userDefinedMaxLength ) {
        $( `.widthHeight__custom .widthHeight__value[name="height__value"] + .widthHeight__item__action-plus` ).click();
      }
    }, 100);
  } catch ( err ) {
    console.log( `ERROR manageProperties()`, err.message );
  }
}

function ratioBy( type, w, h ) {
  try {
    if ( type == 'w' ) {

      let aspectRatio   =   ratio_width / ratio_height;
      // console.log ( 'aspectRatio', aspectRatio );
      return parseFloat( ( h * aspectRatio ).toFixed(2) );

    } else if ( type == 'h' ) {
      let aspectRatio   =   ratio_width / ratio_height;
      return parseFloat( ( w / aspectRatio ).toFixed(2) );
    }
  } catch ( err ) {
    console.log( `ERROR ratioBy`, err.message );
  }
}

async function cartItems() {
  try {
    await $.get('/cart?view=ajax', async function ( r ) {
      $( `cart-drawer.drawer` )
        .removeClass( `is-empty` )
        .find( `.drawer__inner` )
        .html( r );
    });
  } catch ( err ) {
    console.log( `ERROR cartItems()`, err.message );
  }
}

async function add2Cart( obj ) {
  try {
    let rtn;
    await $.post(`/cart/add.js`, obj, function ( r ) {
      rtn   =   r;
    },"json");
    return rtn;
  } catch ( err ) {
    console.log( `ERROR add2Cart`, err.message );
  }
}

function calculateRatio( num_1, num_2 ) {
  num_1 = num_1 * 1;
  num_2 = num_2 * 1;

  for(num=num_2; num>1; num--) {
    if((num_1 % num) == 0 && (num_2 % num) == 0) {
      num_1=num_1/num;
      num_2=num_2/num;
    }
  }
  ratio_width   =   num_1 * 1;
  ratio_height  =   num_2 * 1;
}


function addFilesAsProperties() {
  try {
    location.href = '?new=1';
  } catch ( err ) {
    console.log( `ERROR addFilesAsProperties()`, err.message );
  }
}


// ************
window.addEventListener('cloudlift.upload.ready', function(e) {
  // var uploadField = window.Cloudlift.upload.App.fields[0];
  console.log ( 'upload lift ready',  );
  setTimeout(() => {
    $( `.filepond--root` )
      .prepend( `
        <div class="fileUploading_inprocess">
          ${ typeof uploadData.duringUpload_img !== 'undefined' && uploadData.duringUpload_img ? `<img src="${ uploadData.duringUpload_img }" class="fileUploading_inprocess__img">` : ''  }
          ${ typeof uploadData.duringUpload_heading !== 'undefined' && uploadData.duringUpload_heading ? `<div class="fileUploading_inprocess__heading">${ uploadData.duringUpload_heading }</div>` : ''  }
          ${ typeof uploadData.duringUploadContent !== 'undefined' && uploadData.duringUploadContent ? `<div class="fileUploading_inprocess__content">${ uploadData.duringUploadContent }</div>` : ''  }
        </div>
      ` );
  }, 1000);
  // <div class="fileUploading_inprocess">chaa</div>
});
window.addEventListener('upload:added',async function(e) {
  /* event detail contains the file reference */
  var file = e.detail;
  /* print file on console to see all attributes */
  console.debug('file added', file);

  if(file.url && file.meta.variant === 'thumbnail'){
    console.log('file is thumbnail!');
  }

  /* url contains the link to the file */
  uploadedFile = file.url;
  console.log('new file: ' + file.url);

  if ( file.url != '' ) {

    const addToCartForm = $( `product-form form[data-type="add-to-cart-form"] .customAdd2Cart` ).closest( `form` );
    const isPropertiesEle = addToCartForm.find( `form-properties` ).length;
    if ( isPropertiesEle == 0 ) {
      addToCartForm.append( `
        <form-properties>
          <input type="hidden" name="properties[Upload (Vector Files Preferred)]" value="${ file.url }">
        </form-properties>
      ` );
    }

    console.log ( 'file.url', file.url );

    var fileExt = file.url.split('.').pop();

    console.log ( 'fileExt', fileExt );

    if ( fileExt == 'ai' || fileExt == 'eps' || fileExt == 'pdf' || fileExt == 'psd' || fileExt == 'svg' ) {

      const getApiResponse  =   await sendApiRequest( file.url );
      console.log ( 'getApiResponse', getApiResponse );

      if ( typeof getApiResponse !== 'undefined' && getApiResponse.success === true ) {
        if ( typeof getApiResponse.data.dimensions !== 'undefined' && getApiResponse.data.dimensions ) {
          file_width  =   getApiResponse.data.dimensions.width * 300;
          file_height =   getApiResponse.data.dimensions.height * 300;
        }

        console.log ( 'getApiResponse', getApiResponse );
      } else {
        file_width  =   300;
        file_height =   300;
      }

      $( `.widthHeight__option.customOption .widthHeight__option-detectedSize` )
        .html( `Detected size: <span d-size>${ (file_width / 300).toFixed(2) }" x ${ (file_height / 300).toFixed(2) }"</span>` );

      $( `.widthHeight__block [name="height__value"]` )
        .val( `${ (file_height / 72).toFixed(2) }` );

      $( `.widthHeight__block [name="width__value"]` )
        .val( `${ (file_width / 72).toFixed(2) }` );

      $( `.shopify-block.shopify-app-block [data-upload-field] .cl-upload--input-fields` )
        .show();

      $( `.customUploaderWrapper__upload` )
        .addClass( `hidden` );

      $( `.color-background-1.gradient` )
        .removeClass( `adjustHeight` );

      // $( `.widthHeight__autoChange .autoChange` )
      //   .prop( `checked`, false );

      $( `[item-show-on]` )
        .addClass( `hidden` );

      $( `[item-show-on="afterUpload"]` )
        .removeClass( `hidden` );

      $( `.goToNextStep` )
        .removeClass( `hidden` )
        .click();

      setTimeout(()=>{
        $( `.product-form .product-form__variants .block-swatch[min=""][max=""]` )
          .first()
          .find( `> label` )
          .click();

        setTimeout(()=>{
          const file__W = ( file_width / 300 ).toFixed(2);
          const file__H = ( file_height / 300 ).toFixed(2);

          console.log ( 'file__H', file__H );
          console.log ( 'file__W', file__W );

          if ( file__H > file__W && file__H > 22 ) {
            console.log ( 'chaaa height' );
            $( `.widthHeight__item__action[by="height"] .widthHeight__item__action-plus` ).click();
          } else if ( file__W > file__H && file__W > 22 ) {
            console.log ( 'chaaa width' );
            $( `.widthHeight__item__action[by="width"] .widthHeight__item__action-plus` ).click();
          } else if ( file__W > 22 && file__H > 22 ) {
            console.log ( 'chaaa height' );
            $( `.widthHeight__item__action[by="height"] .widthHeight__item__action-plus` ).click();
          }
        }, 100);
      }, 500);

    } else {


      const img     =   new Image();
      img.onload    =   function() {
        file_width  =   this.width;
        file_height =   this.height;
        // alert(this.width + 'x' + this.height);

        $( `.widthHeight__option.customOption .widthHeight__option-detectedSize` )
          .html( `Detected size: <span d-size>${ (file_width / 300).toFixed(2) }" x ${ (file_height / 300).toFixed(2) }"</span>` );

        $( `.widthHeight__block [name="height__value"]` )
          .val( `${ (file_height / 300).toFixed(2) }` );

        $( `.widthHeight__block [name="width__value"]` )
          .val( `${ (file_width / 300).toFixed(2) }` );

        $( `.shopify-block.shopify-app-block [data-upload-field] .cl-upload--input-fields` )
          .show();

        $( `.customUploaderWrapper__upload` )
          .addClass( `hidden` );

        $( `.color-background-1.gradient` )
          .removeClass( `adjustHeight` );

        $( `.widthHeight__autoChange .autoChange` )
          .prop( `checked`, true );

        $( `[item-show-on]` )
          .addClass( `hidden` );

        $( `[item-show-on="afterUpload"]` )
          .removeClass( `hidden` );

        $( `.goToNextStep` )
          .removeClass( `hidden` )
          .click();

        setTimeout(()=>{
          const file__W = file_width / 300;
          const file__H = file_height / 300;

          if ( file__H > file__W && file__H > 22 ) {
            console.log ( 'chaaa height' );
            $( `.widthHeight__item` )
              .addClass( `error` );
            $( `.widthHeight__item__action[by="height"] .widthHeight__item__action-plus` ).click();
          } else if ( file__W > file__H && file__W > 22 ) {
            console.log ( 'chaaa width' );
            $( `.widthHeight__item` )
              .addClass( `error` );
            $( `.widthHeight__item__action[by="width"] .widthHeight__item__action-plus` ).click();
          } else if ( file__W > 22 && file__H > 22 ) {
            console.log ( 'chaaa height' );
            $( `.widthHeight__item` )
              .addClass( `error` );
            $( `.widthHeight__item__action[by="height"] .widthHeight__item__action-plus` ).click();
          }
        }, 100);
      }
      img.src       =   file.url;

    }

    $(".product-form[action='/cart/add']").find(`input[name="properties[Upload (Vector Files Preferred)]"]`).remove()
    var _clineObj = $( `input[name="properties[Upload (Vector Files Preferred)]"]` ).clone(true);
    var _clineObjMsg = $( `.cl-upload--input` ).clone(true);
    $(_clineObjMsg).attr({"id":"__uploadmsg","class":"hidden"});
    $(".product-form[action='/cart/add']").append(_clineObj);
    $(".product-form[action='/cart/add']").append(_clineObjMsg);
    __carttype();
  }

  $( `.uploaderFooterNoteSimpleLine` ).addClass( `hidden` );

  await addDelay( 1000 );
  // showFinalStep();
  const getStep     =   $( `back-btn` ).attr( `show-step` );

  if ( typeof getStep !== 'undefined' && getStep ) {
    $( `product-form.product-form, .uploaderFooterNote, .designerNote` ).show();
  }

  console.log ( 'upload done' );

});

function __carttype(){
    $(".cl-upload--input").on("keyup",function () {
      var _cmsg = $(this).val();
      $("#__uploadmsg").val(_cmsg);
    })
}

window.addEventListener('upload:removed', function(e) {
  /* event detail contains the file reference */

  let file = e.detail;
  $( `form-properties` ).remove();
  $( `.goToNextStep` )
    .addClass( `hidden` );

  $( `[item-show-on]` )
    .addClass( `hidden` );

  $( `[item-show-on="beforeUpload"], [item-show-on="onAll"]` )
    .removeClass( `hidden` );

  $( `.customTabelPlace__item.selected` )
    .removeClass( `selected` );

  $( `.customQtyFile__qty` )
    .val( 1 )
    .prop( 1 );

  $( `.product` )
    .removeClass( `changeLayout` );

  $( `.step__1` )
    .removeClass( `hidden` );

  $( `.step__2` )
    .addClass( `hidden` );

  $( `.shopify-block.shopify-app-block [data-upload-field] .cl-upload--input-fields` )
    .hide();

  ratio_width   =   0;
  ratio_height  =   0;

  uploadedFile = '';
});


async function sendApiRequest( fileUrl ) {
  try {
    if ( fileUrl != '' ) {
      let rtn;
      const endCode = encodeURI( fileUrl );
      await $.get(`${ apiURL + endCode }`, function ( res ) {
        rtn   =   res;
      });
      return rtn;
    }
  } catch ( err ) {
    console.log( `ERROR sendApiRequest`, err.message );
  }
}


function selectCurrentImage( o ) {
  try {
    $( `.product__mainImg` )
      .attr( `src`, o.large )
      .fadeIn();

    $( `.product__mainImgWrap iframe` )
      .fadeOut();

    $( `media-gallery .product__thumbItem` )
      .removeClass( `selected` );

    $( `.product__thumbItem.currentVariant` )
      .attr( `img`, o.large )
      .addClass( `selected` )
      .find( `img` )
      .attr( `src`, o.thumb );

  } catch ( err ) {
    console.log( `ERROR selectCurrentImage`, err.message );
  }
}

const getMeta = async (url, cb) => {
  const img   =   new Image();
  img.onload  =   () => cb(null, img);
  img.onerror =   (err) => cb(err);
  img.src     =   url;
};

async function manageSteps( hideStep, showStep ) {
  try {
    const step_1_elements = '.pdp__block.customTitle, .customReviews, .pdp__block.customDescription, .customBadgesPlace, .customBadgesPlace+hr, .customVariants, .customContent, .product-form__input.product-form__quantity, .customTabelPlace, .customPrecut, .customQtyFile, .customTabelPlaceWrap';
    const step_2_elements = '.shopify-block.shopify-app-block [data-upload-field], .customStep2_upload_title, .customStep2_upload_description, .customStep2_upload_list .uploaderStep2FooterBtn';
    const step_3_elements = '.afterUploadAdd2Cart, .customStep2_upload_title, .customStep2_upload_description, .customStep2_upload_list';
    if ( hideStep == 1 ) {
      $( step_1_elements )
        .hide();
    } else if ( hideStep == 2 ) {
      $( step_2_elements )
        .hide();
    } else if ( hideStep == 3 ) {
      $( step_3_elements )
        .hide();
    }

    if ( showStep == 1 ) {
      $( step_1_elements )
        .show();
    } else if ( showStep == 2 ) {
      $( step_2_elements )
        .show();
    } else if ( showStep == 3 ) {
      $( step_3_elements )
        .show();
    }

  } catch ( err ) {
    console.log( `ERROR manageSteps`, err.message );
  }
}

async function setSteps( hideStep, showStep ) {
  try {
    $( `.customStep2_upload back-btn` )
      .attr({
        "show-step": showStep,
        "hide-step": hideStep
      });
    if ( showStep == 1 ) {
      $( `.customStep2_upload back-btn` )
        .removeClass( `makeItHide` );
    } else {
      $( `.customStep2_upload back-btn` )
        .addClass( `makeItHide` );
    }
  } catch ( err ) {
    console.log( `ERROR setSteps`, err.message );
  }
}


function showFinalStep() {
  try {

    // const checkFooterLine = $( `.uploaderStep2FooterBtn` ).length;
    // if ( checkFooterLine == 0 ) {
    //   $( `.shopify-block.shopify-app-block [data-upload-field]` )
    //   .append( `
    //     <div class="uploaderStep2FooterBtn">
    //       Next Step
    //     </div>
    //   ` );
    // }
    // console.log ( 'yes got value' );
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

function checkingFieldVal( selectorIs, functionName, timer, args='' ) {
  try {
    var divCheckingInterval                   =   setInterval( function() {
      if ( document.querySelector( selectorIs ).value != '' ) {
        clearInterval( divCheckingInterval );
        if ( typeof functionName !== 'undefined' && functionName ) {
          window[functionName]( args ? args : '' );
        }
        return true;
      }
    }, timer != '' ? timer : 250);
    return false;
  } catch ( err ) {
    console.log( `ERROR checkingFieldVal`, err.message );
  }
}

function checkingElement( selectorIs, functionName, timer, args='' ) {
  try {
    var divCheckingInterval                   =   setInterval( function() {
      if ( document.querySelector( selectorIs ) ) {
        clearInterval( divCheckingInterval );
        if ( typeof functionName !== 'undefined' && functionName ) {
          window[functionName]( args ? args : '' );
        }
        return true;
      }
    }, timer != '' ? timer : 250);
    return false;
  } catch ( err ) {
    console.log( `ERROR checkingElement`, err.message );
  }
}

async function add2Cart( obj ) {
  try {
    let rtn;
    await $.post(`/cart/add.js`, obj, function ( r ) {
      rtn = r;
    },"json");
    return rtn;
  }
  catch ( err ) {
    console.log( `ERROR add2Cart`, err.message );
  }
}

function uploaderDataManage() {
  if ( typeof uploadData !== 'undefined' && uploadData ) {
    const isSimpleLineAvailable = $( `.uploaderFooterNoteSimpleLine` ).length;
    if ( isSimpleLineAvailable == 0 ) {
      // $( `.cl-upload--input-field` )
      // .before( `
      //   <div class="uploaderFooterNoteSimpleLine">${ uploadData.beforeFileUpoadNote }</div>
      // ` );
    }
    if ( typeof uploadData.underUploaderNote !== 'undefined' && uploadData.underUploaderNote ) {
      const uploaderStep2FooterBtn    =   $( `.uploaderStep2FooterBtn` ).length;
      const checkFooterLine           =   $( `.uploaderFooterNote` ).length;
      if ( checkFooterLine == 0 ) {
        const getDesignNote           =   $( `[name="properties[Design Notes]"]` ).val();
        $( `[name="properties[Design Notes]"]` )
          .prop( 'disabled', true )
          .attr( `type`, `hidden` )
          .before( `
            <div class="uploaderFooterNote">
              ${ uploadData.underUploaderNote }
            </div>
            <textarea class="designerNote" name="properties[Design Notes]" placeholder="ex. Remove background & make sure design is 3.5\" wide">${ getDesignNote }</textarea>
          ` );
      }
    }
  }

  const selectedQty = $( `.customQtyFile__qty` ).val();
  const isQtyElement = $( `product-form.product-form form[action="/cart/add"] [name="quantity"]` ).length;
  if ( isQtyElement == 0 ) {
    $( `product-form.product-form form[action="/cart/add"]` )
      .append( `
        <input type="hidden" name="quantity" value="${ selectedQty }">
      ` );
  } else {
    $( `product-form.product-form form[action="/cart/add"] [name="quantity"]` ).val( selectedQty );
  }
}

function getData( type ) {
  try {
    const dataArr = [['1 - 9', '0%', 'discount']];
    $( `.quantity-breaks-now-discount-table .qb-discount-table-row` ).each(function(i) {
      let collobj = [];
      $( this ).find( `td` ).each(function() {
        const text = $( this ).text().trim();
        collobj.push( text )
      })

      dataArr.push( collobj );
    })

    let tableHTML = '';
    dataArr.forEach(el => {
      tableHTML +=  `<div class="customTabelPlace__item">`;
        el.forEach((col, i) => {
          tableHTML +=  `<div class="customTabelPlace__item_${ i + 1 }">${ col }</div>`;
        });
      tableHTML +=  `</div>`;
    });

    console.log ( 'dataArr', dataArr );

    $(`.customTabelPlace.colList` )
      .attr( `items`, dataArr.length )
      .html( tableHTML )
      .removeClass( `hide` );

    if ( type != 'onLoad' ) {
      const getOp_1 = $( `.product-form__input[op="1"] input:checked` ).val();
      const getOp_2 = $( `.product-form__input[op="2"] input:checked` ).val();

      if ( typeof getOp_1 !== 'undefined' && getOp_1 && typeof getOp_2 !== 'undefined' && getOp_2 && typeof allVariants !== 'undefined' && allVariants && typeof findObjectByKey === 'function' ) {
        const selectedVariant_ob = findObjectByKey( allVariants, 'title', `${ getOp_1 } / ${ getOp_2 }` );
        if ( typeof selectedVariant_ob.id !== 'undefined' && selectedVariant_ob.id ) {
          $( `[name="id"]` ).val( selectedVariant_ob.id );

          $( `.product__mainImg` )
            .attr( `src`, selectedVariant_ob.large )
            .fadeIn();
          $( `.product__mainImgWrap iframe` )
            .fadeOut();
          $( `media-gallery .product__thumbItem` )
            .removeClass( `selected` );
          $( `.product__thumbItem.currentVariant` )
            .attr( `img`, selectedVariant_ob.large )
            .addClass( `selected` )
            .find( `img` )
            .attr( `src`, selectedVariant_ob.thumb );
        }
      }
    }
  } catch ( err ) {
    console.log( `ERROR getData()`, err.message );
  }
}

// MODAL EVENTS START
$( document )
.on(`click`, `.customBadgesPlace__item[popup="true"]`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const getBlockID = $( this ).attr( `block` );
    $( `.modalDialog[block="${ getBlockID }"]` ).fadeIn();
    const isIframeAvailable = $( `.modalDialog[block="${ getBlockID }"] .modalDialog__centerCenter__content--detail iframe` ).length;
    const isIframeOldSrcAvailable = $( `.modalDialog[block="${ getBlockID }"] .modalDialog__centerCenter__content--detail iframe[src-old]` ).length;
    if ( isIframeAvailable > 0 && isIframeOldSrcAvailable > 0 ) {
      const videoSrc = $( `.modalDialog[block="${ getBlockID }"] .modalDialog__centerCenter__content--detail iframe` ).attr( `src-old` );
      $( `.modalDialog[block="${ getBlockID }"] .modalDialog__centerCenter__content--detail iframe` )
        .removeAttr( `src-old` )
        .attr( `src`, videoSrc );
    }
  } catch ( err ) {
    console.log( `ERROR .customBadgesPlace__item[popup="true"]`, err.message );
  }
})
.on(`click`, `.modalDialog__centerCenter__close`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this ).closest( `.modalDialog` ).fadeOut();
    const isIframeAvailable = $( this ).closest( `.modalDialog` ).find( `.modalDialog__centerCenter__content--detail iframe` ).length;
    console.log ( 'isIframeAvailable', isIframeAvailable );
    if ( isIframeAvailable > 0 ) {
      const videoSrc = $( this ).closest( `.modalDialog` ).find( `.modalDialog__centerCenter__content--detail iframe` ).attr( `src` );
      $( this ).closest( `.modalDialog` ).find( `.modalDialog__centerCenter__content--detail iframe` )
        .removeAttr( `src` )
        .attr( `src-old`, videoSrc );
    }
  } catch ( err ) {
    console.log( `ERROR .modalDialog__centerCenter__close`, err.message );
  }
})
;
// MODAL EVENTS END

function cartCountUpdate() {
  try {
    $.get(`/cart?view=itemsCount`, function ( res ) {
      $( `#cart-icon-bubble` ).html( res );
    });
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}


function findObjectByKey(array, key, value, multiple) {
  try {
    let rtn = [];
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        if ( multiple ) {
          rtn.push( array[i] );
        } else {
          return array[i];
        }
      }
    }
    if ( multiple && rtn.length > 0 ) {
      return rtn;
    } else {
      return null;
    }
  }
  catch ( err ) {
    console.log( `ERROR findObjectByKey`, err.message );
  }
}

function ElementAvailibility ( selectorIs, functionName, timer, args='' ) {
  try {
    var divCheckingInterval                   =   setInterval( function() {
      if ( document.querySelector( selectorIs ) ) {
        clearInterval( divCheckingInterval );
        if ( typeof functionName !== 'undefined' && functionName ) {
          window[functionName]( args ? args : '' );
        }
        return true;
      }
    }, timer != '' ? timer : 250);
    return false;
  } catch ( err ) {
    console.log( `ERROR checkingElement`, err.message );
  }
}

function getParam( paramIs ) {
  try {
    const url = location.href;
    const objURL = new URL(url);
    const c = objURL.searchParams.get( paramIs );
    return c;
  }
  catch ( err ) {
    console.log ( 'ERROR getParam', err.message );
  }
}